import { render, staticRenderFns } from "./CommentPanel.vue?vue&type=template&id=7d91005e&"
import script from "./CommentPanel.vue?vue&type=script&lang=js&"
export * from "./CommentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports